import { lifecycle, compose } from "recompose";
import { graphql } from "react-apollo";
import HeaderQuery from "theme/layouts/Header/HeaderQuery.gql";

const triggerQuoteDataLayer = () => {
  if (typeof this === "undefined") {
    return;
  }
  const quote = this.props.quote;

  if (quote && quote.items_qty) {
    const QuoteLayer = {
      ecomm_totalvalue:
        quote && quote.totals ? quote.totals.totalExclTax.value.amount : 0,
      ecomm_prodid:
        quote && quote.items.length ? quote.items.map((item) => item.sku) : "",
    };
    window.dataLayer = window.dataLayer || [];
    if (window.dataLayer["google_tag_params"]) {
      window.dataLayer["google_tag_params"].push(QuoteLayer);
    } else {
      window.dataLayer.push({
        google_tag_params: QuoteLayer,
      });
    }
  }
};
const withQuoteDataLayer = compose(
  graphql(HeaderQuery, {
    props: ({ data }) => ({
      quote: data.cart,
    }),
  }),
  lifecycle({
    componentDidMount: function () {
      triggerQuoteDataLayer();
    },
    componentDidUpdate: () => {
      //triggerQuoteDataLayer();
    },
  })
);

export default withQuoteDataLayer;
